@if (action == 'confirm') {
  <div class="card mt-4">
    <h4 class="card-header">Confirmation - Deletion of your Account - Entrarit</h4>
    <p class="mx-2">We are sorry to see you go. Thank you for your support</p>
    <p class="mx-2">Please fill out form below to confirm deletion of your account</p>
    <form class="mx-4" [formGroup]="deleteAccountFormConfirm" (ngSubmit)="onSubmitConfirm()">
      <div class="form-group col-md-6">
        <label class="sr-only" for="tokencode">Token Code</label>
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text"><fa-icon [icon]="faKey"></fa-icon></div>
          </div>
          <input type="text" formControlName="tokencode" class="form-control py-0" name="tokencode" id="tokencode"  placeholder="Token code" [ngClass]="{ 'is-invalid': submitted && fc.tokencode.errors, 'is-valid': fc.tokencode.valid && fc.tokencode.touched }" >
          @if (fc.tokencode && fc.tokencode.errors) {
            <div class="invalid-feedback">
              @if (fc.tokencode.errors.required) {
                <div>Token code required (check email inbox or junk folder for token code)</div>
              }
            </div>
          }
        </div>
      </div>
      <div class="form-group col-md-6">
        <label class="sr-only" for="email">Email</label>
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text"><fa-icon [icon]="faEnvelope"></fa-icon></div>
          </div>
          <input type="email" formControlName="email" class="form-control py-0" name="email" id="email"  placeholder="Email" [pattern]="emailPattern"  [ngClass]="{ 'is-invalid': submitted && fc.email.errors, 'is-valid': fc.email.valid && fc.email.touched }" >
          @if (submitted && fc.email.errors) {
            <div class="invalid-feedback">
              @if (fc.email.errors.required) {
                <div>Email is required</div>
              }
            </div>
          }
          @if (fc.email && fc.email.errors?.pattern) {
            <div class="invalid-feedback">
              Email address is not valid
            </div>
          }
        </div>
        <div class="form-group my-4">
          <button [disabled]="loading" class="btn btn-success float-right">
            @if (loading) {
              <span class="spinner-border spinner-border-sm mr-1"></span>
            }
            Submit <fa-icon class="l-icon" [icon]="faPaperPlane"></fa-icon>
          </button>
        </div>
      </div>
    </form>
  </div>
}
@if (action == '' || action == undefined || action == null) {
  <div class="card mt-4">
    <h4 class="card-header">Delete Your Account - Entrarit</h4>
    <p class="my-4 mx-2">Your right to be forgotten will be allowed on this platform.</p>
    <p class="mx-2">Please fill out form below to submit your request to delete your account</p>
    <form class="mx-4" [formGroup]="deleteAccountForm" (ngSubmit)="onSubmit()">
      <div class="form-group col-md-6">
        <label class="sr-only" for="fullname">Full Name</label>
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text"><fa-icon [icon]="faUser"></fa-icon></div>
          </div>
          <input type="text" formControlName="fullname" class="form-control py-0" name="fullname" id="fullname" [pattern]="fullNamePattern" placeholder="First and Last name" [ngClass]="{ 'is-invalid': submitted && f.fullname.errors, 'is-valid': f.fullname.valid && f.fullname.touched }" >
          @if (f.fullname && f.fullname.errors) {
            <div class="invalid-feedback">
              @if (f.fullname.errors.required) {
                <div>Full name must be entered e.g John Brown</div>
              }
            </div>
          }
          @if (f.fullname && f.fullname.errors?.pattern ) {
            <div class="invalid-feedback">
              Full name must be entered in the format First Last e.g John Brown
            </div>
          }
        </div>
      </div>
      <div class="form-group col-md-6">
        <label class="sr-only" for="email">Email</label>
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text"><fa-icon [icon]="faEnvelope"></fa-icon></div>
          </div>
          <input type="email" formControlName="email" class="form-control py-0" name="email" id="email"  placeholder="Email" [pattern]="emailPattern"  [ngClass]="{ 'is-invalid': submitted && f.email.errors, 'is-valid': f.email.valid && f.email.touched }" >
          @if (submitted && f.email.errors) {
            <div class="invalid-feedback">
              @if (f.email.errors.required) {
                <div>Email is required</div>
              }
            </div>
          }
          @if (f.email && f.email.errors?.pattern) {
            <div class="invalid-feedback">
              Email address is not valid
            </div>
          }
        </div>
        <div class="form-group my-4">
          <button [disabled]="loading" class="btn btn-success float-right">
            @if (loading) {
              <span class="spinner-border spinner-border-sm mr-1"></span>
            }
            Submit <fa-icon class="l-icon" [icon]="faPaperPlane"></fa-icon>
          </button>
        </div>
      </div>
    </form>
  </div>
}

